// Resolves iOS option icon names to real extracted assets (preferred) or an
// emoji fallback. Assets live in client/public/onboarding-assets/ (see
// scripts/extract-onboarding-assets.js).
const BASE = (process.env.PUBLIC_URL || '') + '/onboarding-assets/';

// Monochrome navy icons that iOS tints (dark when selected, gray otherwise).
const MONO_ICONS = new Set([
  'male', 'female',
  'goal_lose_weight', 'goal_maintain_weight', 'goal_gain_weight',
  'eat_live_heltier', 'boost_energy_mood', 'feel_better_body',
]);

// Full-color brand icons (rendered as-is, no tint) — referral source.
const COLOR_ICONS = new Set([
  'appstore', 'instagram', 'tiktok', 'youtube', 'facebook', 'pinterest', 'gpt', 'other',
]);

// Emoji fallback for icons that have no extracted asset.
const ICON_GLYPHS = {
  photo_frequency_camera: '📷',
  telegram: '✈️',
  friend_family: '👥',
  doctor_trainer: '🩺',
};

export function iconKind(name) {
  if (!name) return 'none';
  if (COLOR_ICONS.has(name)) return 'color';
  if (MONO_ICONS.has(name)) return 'mono';
  return ICON_GLYPHS[name] ? 'glyph' : 'none';
}

export function assetUrl(name) {
  return name ? BASE + name + '.png' : null;
}

export function iconGlyph(name) {
  return (name && ICON_GLYPHS[name]) || null;
}

export const ASSET = (file) => BASE + file;
